// apps/hub/src/config/links.ts
// Source unique des liens externes du Hub.
// Les apps NeuroForge sont résolues depuis les env vars `VITE_*_URL` avec un
// fallback sur les domaines de prod `*.neuroforge.link` (évite tout lien cassé
// si une env var manque). Cf. HUB-CONFIG-01 (docs/AUDIT-HUB.md).

/** Apps de l'écosystème NeuroForge. */
export const EXTERNAL_LINKS = {
  academy: import.meta.env.VITE_ACADEMY_URL ?? 'https://academy.neuroforge.link',
  prompts: import.meta.env.VITE_PROMPTS_URL ?? 'https://prompts.neuroforge.link',
  forge: import.meta.env.VITE_FORGE_URL ?? 'https://forge.neuroforge.link',
  hub: import.meta.env.VITE_HUB_URL ?? 'https://hub.neuroforge.link',
} as const

/** Réseaux sociaux / communauté. */
export const SOCIAL_LINKS = {
  discord: 'https://discord.gg/QtQ6PmuZ6M',
  facebook: 'https://www.facebook.com/neuroforge.link',
  // TODO: renseigner l'URL du Groupe Facebook une fois créé (communauté n°1 grand public)
  // group: 'https://www.facebook.com/groups/xxxxxxxx',
  tiktok: 'https://www.tiktok.com/@neuroforge.link',
  youtube: 'https://www.youtube.com/@NeuroForgeAI-link',
} as const
